// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//引入根页面
import App from './App'
import router from './router'

//引入公共的css
import "../static/comment.css"

//引入动画animate.css
import animated from 'animate.css'

Vue.use(animated)

//引入axios
import Axios from 'axios'
Vue.prototype.$axios = Axios

Vue.config.productionTip = false


// 引入rem文件
import "../vuex/rem"

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


//引入socket.io
import VueSocketio from 'vue-socket.io';
Vue.use(new VueSocketio({
  debug: true,
  connection: 'https://qimmos.cn', //地址+端口，由后端提供
}));


//引入谷歌地图


// import vueGooglemap from 'vue2-googlemap';

// Vue.use(vueGooglemap);

// vueGooglemap.initGooglemap({
//   key: 'AIzaSyB7W8BmdHQ7X8m160amh5hpK6DbYoLOkaE',
//   language: 'zh-CN',
//   v: '3',
// })





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: c => c(App)
})



// WEBPACK FOOTER //
// ./src/main.js